import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["popoverType", "isSubmitDisabled", "linkType", "onSubmit", "onCancel", "renderLinkPopoverAlert"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ExplicitSaveControls(props) {
  const {
      popoverType,
      isSubmitDisabled,
      linkType,
      onSubmit,
      onCancel,
      renderLinkPopoverAlert
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsxs(View, Object.assign({}, rest, {
    children: [typeof renderLinkPopoverAlert === 'function' ? renderLinkPopoverAlert(linkType) : null, /*#__PURE__*/_jsx(Button
    // @TODO: Rename this to `explicit-save-submit-button` along with
    // all consumer references
    , {
      "data-test-id": "submit-link-confirm-button",
      disabled: isSubmitDisabled,
      size: "small",
      use: "tertiary",
      onClick: onSubmit,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `RichTextLib.explicitSave.submit.${popoverType}`
      })
    }), /*#__PURE__*/_jsx(Button, {
      "data-test-id": "explicit-save-cancel-button",
      marginInlineStart: "300",
      size: "small",
      use: "transparent",
      onClick: onCancel,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "RichTextLib.explicitSave.cancel"
      })
    })]
  }));
}
ExplicitSaveControls.displayName = 'ExplicitSaveControls';
export default ExplicitSaveControls;